import React from 'react';
import { Collapse, theme } from 'antd';
import { useFaqData } from './useFAQData';
import st from './style.module.scss';

const FaqSection = ({ type }) => {
  const { token } = theme.useToken();
  const panelStyle = {
    // fontWeight: 'bold',
    // fontSize: '18px',
    marginBottom: 24,
    backgroundColor: 'rgba(132, 36, 46, .05)',
    borderRadius: token.borderRadiusLG,
    border: 'none',
  };
  const { Panel } = Collapse;
  const { getFAQData } = useFaqData();
  const FAQ_DATA = getFAQData();
  const { items, faqTitle } = FAQ_DATA[type];
  return (
    <section className={st.faqSection}>
      <h3 className={st.faqSectionTitle}>{faqTitle}</h3>
      <Collapse bordered={false} accordion style={{ background: token.colorBgContainer }}>
        {items.map(item => (
          <Panel key={item.key} header={item.label} style={panelStyle} className={st.panelStyle}>
            <p className={st.faqSectionDescription}>{item.description}</p>
          </Panel>
        ))}
      </Collapse>
    </section>
  );
};

export default FaqSection;
